module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "kt-banner"
  }, [_c('span', {
    staticStyle: {
      "position": "absolute",
      "top": "150px",
      "left": "358px"
    }
  }, [_c('font', {
    staticStyle: {
      "font-size": "100px",
      "letter-spacing": "12pt"
    },
    attrs: {
      "color": "#22aef8"
    }
  }, [_vm._v("控糖百科")]), _c('br'), _vm._v(" "), _c('font', {
    staticStyle: {
      "width": "434px",
      "height": "33px",
      "font-size": "30px",
      "font-family": "MicrosoftYaHei",
      "color": "rgba(103,190,236,1)",
      "line-height": "36px"
    },
    attrs: {
      "color": "#22aef8"
    }
  }, [_vm._v("Sugar Controlled Encyclopedia")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('hr', {
    staticStyle: {
      "position": "absolute",
      "margin": "62px 270px",
      "width": "920px",
      "height": "1px",
      "background-color": "#D9D9D9"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "400px",
      "width": "200px",
      "height": "33px"
    }
  }), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-demo box-nav",
    attrs: {
      "active-text-color": "#00b9cd",
      "mode": "vertical",
      "default-openeds": ['0']
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "214px",
      "height": "66px",
      "background-color": "#02C3D8",
      "margin-top": "-92px",
      "box-shadow": "0px 0px 5px #e9ebeb"
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "65px",
      "color": "#FFF",
      "font-size": "22px",
      "box-shadow": "0px 0px 5px #e9ebeb"
    }
  }, [_vm._v("文章分类")])]), _vm._v(" "), _vm._l((_vm.tags), function(item, i) {
    return _c('label', [_c('el-menu-item', {
      attrs: {
        "index": _vm.tags[i].id
      }
    }, [_vm._v(_vm._s(_vm.tags[i].name))])], 1)
  })], 2)], 1), _vm._v(" "), _vm._l((_vm.list), function(item, i) {
    return _c('a', {
      staticStyle: {
        "margin-left": "270px",
        "display": "inherit"
      },
      attrs: {
        "target": "_blank",
        "href": "" + _vm.host + "/html/news/detail-" + _vm.list[i].id + ".html"
      }
    }, [_c('div', {
      staticClass: "introduction-lists"
    }, [_c('img', {
      staticClass: "list-tus",
      attrs: {
        "src": "" + _vm.host + "" + _vm.list[i].title_img + ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "list-centBoxs"
    }, [_c('span', {
      staticClass: "list-title"
    }, [_vm._v(_vm._s(_vm.list[i].title))]), _vm._v(" "), _c('span', {
      staticClass: "list-cent"
    }, [_vm._v(_vm._s(_vm.list[i].add_time))]), _vm._v(" "), _c('span', {
      staticClass: "list-cent"
    }, [_vm._v(_vm._s(_vm.list[i].summary))])])])])
  }), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 2)]), _vm._v(" "), _c('footerBottomer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eb56f78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/content.vue
// module id = 183
// module chunks = 1